import React from 'react';
import { useSelector } from 'react-redux';
import { getLineScoreState } from '../store/selectors/lineScoreSelector';
import LineScore from '../LineScore';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import linescoreReducer from '../store/reducers/lineScore';

initContainerData.register({
    reducers: {
        linescore: linescoreReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    routes: []
}];

const LineScoreContainer = (props) => {
    const lineScoreState = useSelector(getLineScoreState);

    return (
        <LineScore { ...lineScoreState} {...props } />
    );
};

export default LineScoreContainer;

export { routes };
